var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsGated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15l3.478-3.5M19.5 18.75l4-3.996m-4 7.746l4-4m-22 2h3v2h-3v-2zm11 0h3v2h-3v-2zm4 0v-3l-2-2h-12l-2 2v3zm-4-10h-8l-2 5h12zm-12 8H5m7 0h4.5m3-7h4v11h-4v-11zm0 0L8.125 1.75",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgIsGated;